// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"cP-z","categoryName":"dP-z","categoryNameSearchHeader":"eP-z","categoryContent":"fP-z","bottomAligned":"gP-z","image":"hP-z","imageNoBackground":"iP-z"};